import { Image as AntImage } from "antd";
import styled from "styled-components";
import { DefaultIMG } from "@assets";

export const Loader = styled.div`
  width: 100%;
  height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RootContainer = styled.div`
  position: relative;
`;

export const Title = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  color: ${(props) => props.theme.textColor};
  text-align: center;
`;

export const Top = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
`;

export const Image = styled(AntImage).attrs({
  alt: "icon",
  fallback: DefaultIMG,
  preview: false,
})`
  width: 74px !important;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 12px;
`;

export const Container = styled.div`
  position: relative;
  background: ${(props) => props.theme.white};
  border-radius: 12px;
  margin: 6px 18px;
  height: calc(100vh - 180px);
  overflow-y: auto;
`;

export const Card = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.dark4};
  justify-content: center;
  align-items: center;
`;

export const NoCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0.5;
  padding: 18px 8px;
`;

export const Divider = styled.div`
  width: 1px;
  height: 50px;
  border-right: 1px solid ${(props) => props.theme.dark4};
`;

export const NoText = styled.div`
  color: ${(props) => props.theme.textColor};
  font-weight: 600;
  font-size: 12px;
`;

export const NameCard = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  flex: 1.5;
  padding: 18px 8px;
`;

export const AmountCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  padding: 8px 8px 18px 8px;
`;

export const NameText = styled.div`
  color: ${(props) => props.theme.dark1};
  font-size: 14px;
  font-weight: 600;
`;

export const PhoneText = styled.div`
  color: ${(props) => props.theme.dark3};
  font-size: 11px;
  font-weight: 400;
`;

export const AmountText = styled.div`
  color: ${(props) => props.theme.textColor};
  font-size: 14px;
  font-weight: 600;
`;
